import { PARTNERS } from '@/constants/common';

const ACTIVE_PARTNER_PROJECTS = {
  CompareNI: [
    'taxi',
    'minibus',
    'motorfleet',
    'motorhomeagg',
  ],
  QuoteZone: [
    'motorfleet',
  ],
};

export const usePartnerConfig = async (productName, additionalData, config) => {
  const partner = Object.keys(PARTNERS).find(
    key => PARTNERS[key].includes(config.partner) || PARTNERS[key] === config.partner,
  );

  if (!additionalData?.formMetadata) return additionalData?.formMetadata;

  if (ACTIVE_PARTNER_PROJECTS[partner]?.includes(productName)) {
    const { default: formMetadata } = await import('@/config/partners/' + partner + '/' + productName + '.json');

    const newMetaData = {
      ...additionalData?.formMetadata,
      ...formMetadata,
    };

    if (Object.prototype.hasOwnProperty.call(formMetadata, 'steps')) {
      newMetaData.steps = generateSteps(additionalData.formMetadata, formMetadata);
    }

    return newMetaData;
  }

  return additionalData?.formMetadata;
};

const generateSteps = (additionalFormMetaData, formMetadata) => {
  let steps = additionalFormMetaData?.steps;

  if (!formMetadata?.steps?.length) {
    return steps;
  }

  formMetadata.steps.forEach(partnerStep => {
    partnerStep.questions.forEach(partnerQuestion => {
      steps = steps.map(step => {
        if (step.stepId === partnerStep.stepId) {
          step.questions = step.questions.map(question => {
            if (question.questionId === partnerQuestion.questionId) {
              question.params = { ...question.params, ...partnerQuestion.params };
              return question;
            }

            return question;
          });

          return step;
        }

        return step;
      });
    });
  });

  return steps;
};
